import SectionTitle from "./SectionTitle";
import { bandwidthTips, lagReasons } from "@/mocks/home";

export default function Lag() {
  return (
    <section id="lag" className="bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <SectionTitle
          eyebrow="卡顿怎么办"
          title="播放一直转圈，多半是这几个原因"
          desc="卡顿很少是单一问题，按影响程度从高到低排查，通常第一、二条就能明显改善。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          <div className="lg:col-span-2 space-y-3">
            {lagReasons.map((r) => (
              <div
                key={r.key}
                className="flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-5 rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <div className="sm:w-40 shrink-0">
                  <p className="text-base font-semibold text-foreground-950">{r.key}</p>
                  <span
                    className={`mt-1.5 inline-block px-2 py-0.5 rounded-full text-[11px] font-medium ${
                      r.level === "最常见"
                        ? "bg-accent-100 text-accent-800"
                        : r.level === "常见"
                          ? "bg-secondary-100 text-secondary-900"
                          : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {r.level}
                  </span>
                </div>
                <div className="flex-1">
                  <p className="text-sm text-foreground-600 leading-relaxed">{r.desc}</p>
                  <p className="mt-2 flex items-start gap-2 text-sm text-foreground-900">
                    <i className="ri-arrow-right-s-line text-primary-600 mt-0.5" aria-hidden="true"></i>
                    <span>{r.action}</span>
                  </p>
                </div>
              </div>
            ))}
          </div>

          <aside className="rounded-lg bg-secondary-50 border border-secondary-200 p-6 h-fit">
            <h3 className="flex items-center gap-2 text-base font-semibold text-foreground-950 mb-4">
              <i className="ri-signal-tower-line text-secondary-700" aria-hidden="true"></i>
              清晰度与网络需求参考
            </h3>
            <div className="space-y-3">
              {bandwidthTips.map((t) => (
                <div key={t.quality} className="rounded-md bg-background-50 border border-secondary-200 px-4 py-3">
                  <div className="flex items-center justify-between gap-2">
                    <span className="text-sm font-semibold text-foreground-950">{t.quality}</span>
                    <span className="text-[11px] text-secondary-800">{t.scene}</span>
                  </div>
                  <p className="mt-1 text-xs text-foreground-600">{t.need}</p>
                </div>
              ))}
            </div>
            <p className="mt-4 text-xs text-foreground-600 leading-relaxed">
              提示：以上为一般性参考，实际体验受设备性能、同时在线人数与运营商线路影响。
            </p>
          </aside>
        </div>
      </div>
    </section>
  );
}